module.exports = __webpack_public_path__ + "img/kma_gallery15.a0ea84e5.jpg";